var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.theme }, [
    _c(
      "div",
      { class: this.theme === "blue" && _vm.isLongChart ? "foot1" : "foot" },
      [
        _vm.language === "zh"
          ? _c("img", {
              class:
                this.theme === "purple" && _vm.isLongChart ? "font1" : "font",
              attrs: { src: _vm.zhImg, alt: "mzsm Image" },
            })
          : _vm.language === "en"
          ? _c("img", {
              staticClass: "font",
              attrs: { src: _vm.enImg, alt: "mzsm Image" },
            })
          : _vm._e(),
        _c("div", { staticClass: "qrcode" }, [
          _c("img", {
            staticClass: "code-img",
            attrs: { src: _vm.qrCodeImage, alt: "qrcode Image" },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }